import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import {
    REQUEST_CREATE_AND_SCHEDULE_EVENT,
    REQUEST_LIST_EVENTS,
    REQUEST_LIST_SCHEDULES,
    REQUEST_LIST_SCHEDULABLES,
    REQUEST_REMOVE_EVENT,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/schedule/scheduleMsgs";
import { SchedulableEventAndScheduleCreator } from "userful-chronos-app-common-js/dist/models/schedule/event";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { PassiveMapperComp } from "userful-chronos-app-common-js/dist/models/mapping/MappingGroups";
import {
    REQUEST_CREATE_PASSIVE_MAPPER,
    REQUEST_LIST_PASSIVE_MAPPERS,
    REQUEST_REMOVE_PASSIVE_MAPPER,
    REQUEST_START_PASSIVE_MAPPER,
    REQUEST_STOP_PASSIVE_MAPPER,
    REQUEST_UPDATE_PASSIVE_MAPPER,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/mapping/MappingMsgDefinations";

// Schedulable
export const requestQuerySchedulables = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_SCHEDULABLES);
};

// Events
export const requestListEvens = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_EVENTS);
};

export const requestCreateAndScheduleEvent = (payload: SchedulableEventAndScheduleCreator) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_CREATE_AND_SCHEDULE_EVENT, payload);
};

export const requestRemoveEvent = (payload: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_EVENT, payload);
};

// Schedule
export const requestListSchedules = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_SCHEDULES);
};

// Mapper Schedulable
export const requestListPassiveMappers = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_PASSIVE_MAPPERS);
};

export const requestCreatePassiveMapper = (payload: PassiveMapperComp) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_CREATE_PASSIVE_MAPPER, payload);
};

export const requestUpdatePassiveMapper = (payload: PassiveMapperComp) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSIVE_MAPPER, payload);
};

export const requestRemovePassiveMapper = (payload: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_PASSIVE_MAPPER, payload);
};

export const requestStartMapper = (payload: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_START_PASSIVE_MAPPER, payload);
};

export const requestStopMapper = (payload: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_STOP_PASSIVE_MAPPER, payload);
};
